/**
 * UpCart compatibility shim for the native AOV cart drawer.
 *
 * The theme's custom sections (pdp-sticky-cta, pdp-midi-pricing,
 * pdp-midi-bundle-savings, emotions-promo-hero, cpg-card-atc) call UpCart's
 * JS API and dispatch upcart:* events. This shim answers that surface and
 * forwards to <aov-cart-drawer>, so those files need zero edits at cutover.
 *
 * Stand-down behavior: the shim only claims globals that are free, and its
 * event listeners no-op while a real UpCart is present. Re-enabling the
 * UpCart app embed therefore rolls everything back with no code changes.
 */
const SHIM_FLAG = '__aovShim';

function drawer() {
  return document.querySelector('aov-cart-drawer');
}

function realUpcartPresent() {
  return [window.upcart, window.uCart, window.UpCart].some(
    (candidate) => candidate && !candidate[SHIM_FLAG]
  );
}

function openDrawer() {
  return drawer()?.refreshAndOpen?.();
}

function refreshDrawer() {
  return drawer()?.refresh?.();
}

function makeApi() {
  const api = {
    open: openDrawer,
    show: openDrawer,
    openCart: openDrawer,
    openDrawer: openDrawer,
    toggle: () => drawer()?.toggleDialog?.(),
    close: () => drawer()?.close?.(),
    hide: () => drawer()?.close?.(),
    refresh: refreshDrawer,
    reload: refreshDrawer,
    update: refreshDrawer,
  };
  api[SHIM_FLAG] = true;
  return api;
}

if (!window.upcart) window.upcart = makeApi();
if (!window.uCart) window.uCart = makeApi();
if (!window.UpCart) window.UpCart = makeApi();
if (!window.UC) {
  window.UC = { cart: makeApi() };
  window.UC[SHIM_FLAG] = true;
}

const OPEN_EVENTS = ['upcart:open'];
const REFRESH_EVENTS = ['upcart:refresh', 'upcart:cart-updated', 'upcart:cart:refresh'];

for (const name of OPEN_EVENTS) {
  document.addEventListener(name, () => {
    if (realUpcartPresent()) return;
    openDrawer();
  });
}

for (const name of REFRESH_EVENTS) {
  document.addEventListener(name, () => {
    if (realUpcartPresent()) return;
    refreshDrawer();
  });
}
